export default (form) => {
    const namespace = 'confirmAndValidate';
    const fieldsToValidate = form.querySelectorAll(`[name^="${namespace}"]`);

    fieldsToValidate.forEach((field) => {
        const name = field.getAttribute('name').split(namespace)[1];
        const original = form.querySelector(`[name="${name.toLowerCase()}"]`);
        
        form.addEventListener('change', () => {
            if (original.value != field.value) {
                field.setCustomValidity(`Does not match ${name}`);
            } else {
                field.setCustomValidity('');
            }
        });
    });
};